import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import { AuthConfigService, OAuthLibWrapperService, WindowRef } from '@spartacus/core'
import { OAuthService, TokenResponse } from 'angular-oauth2-oidc'
import { isPlatformServer } from '@angular/common'
import { of } from 'rxjs'

const OAUTH_SCOPE_ASM = 'asm'

@Injectable({
  providedIn: 'root'
})
export class MbOauthLibWrapperService extends OAuthLibWrapperService {

  constructor (protected oAuthService: OAuthService,
              protected authConfigService: AuthConfigService,
              @Inject(PLATFORM_ID) protected platformId: any,
              protected winRef: WindowRef) {
    super(oAuthService, authConfigService, platformId, winRef)
  }

  initialize (doLogin = false, asm?: boolean) {
    const authConfig = this.authConfigService.getOAuthLibConfig()
    // send asm scope to keycloak so that the sap-commerce knows we have a employee
    const extraConfig = {
      ...authConfig,
      ...authConfig.scope && { scope: `${authConfig.scope}${asm && ` ${OAUTH_SCOPE_ASM}` || ''}` } || {},
    }
    const pathname = this.winRef.nativeWindow?.location.pathname
    const contextPath = pathname?.split('/')?.[1]
    const isSSR = isPlatformServer(this.platformId)
    this.oAuthService.configure({
      tokenEndpoint: this.authConfigService.getTokenEndpoint(),
      loginUrl: this.authConfigService.getLoginUrl(),
      clientId: this.authConfigService.getClientId(),
      dummyClientSecret: this.authConfigService.getClientSecret(),
      revocationEndpoint: this.authConfigService.getRevokeEndpoint(),
      logoutUrl: this.authConfigService.getLogoutUrl(),
      userinfoEndpoint: this.authConfigService.getUserinfoEndpoint(),
      issuer: this.authConfigService.getOAuthLibConfig()?.issuer ?? this.authConfigService.getBaseUrl(),
      redirectUri: !isSSR && `${this.winRef.nativeWindow?.location.origin}/${contextPath}/` || '',
      ...extraConfig,
    })
  }

  authorizeWithPasswordFlow (userId: string, password: string) {
    this.initialize(true)
    this.oAuthService.resetImplicitFlow()
    this.oAuthService.initLoginFlow()
    return of({} as TokenResponse).toPromise()
  }

  initLoginFlow () {
    this.initialize(false)
    this.oAuthService.resetImplicitFlow()
    return this.oAuthService.initLoginFlow()
  }
}
